export default __webpack_public_path__ + "static/media/Group 4752.fcdfe7cc.svg";